/* eslint-disable react/destructuring-assignment */
/* eslint-disable react/prop-types */
/* eslint-disable @typescript-eslint/camelcase */
/* eslint-disable camelcase */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Collapsible from 'react-smooth-collapse';
import _round from 'lodash/round';
import _padEnd from 'lodash/padEnd';
import cn from 'classnames';
import TextCropper from '@omilia/text-cropper';
import Tooltip from '@omilia/tooltip';
import Icon from '@omilia/icon';

import { flattenFeatures } from 'store/utils/intents';

import FeaturesList from './components/FeaturesList';

import './style.scss';

function MachineLearningPrediction() {
  return (
    <Tooltip content="Machine Learning Prediction">
      <Icon data-test="mlp-icon" glyph="machine-learning" size="14" />
    </Tooltip>
  );
}

export default class TestResultIntent extends Component {
  static propTypes = {
    intent: PropTypes.shape({
      color: PropTypes.string,
      id: PropTypes.string,
      selection_entities: PropTypes.array,
    }).isRequired,
    isExpandedAll: PropTypes.bool.isRequired,
    onSelect: PropTypes.func.isRequired,
  };

  state = {
    isExpanded: this.props.isExpandedAll,
  };

  componentWillReceiveProps({ isExpandedAll }) {
    this.setState({
      isExpanded: isExpandedAll,
    });
  }

  toggle = () => {
    this.setState(prevState => ({
      isExpanded: !prevState.isExpanded,
    }));
  };

  round = (number, digits) => {
    const rounded = _round(number, digits);

    return rounded < 1 ? _padEnd(_round(number, digits), 4, 0) : rounded;
  };

  roundToTwoDecimals = number => {
    switch (number) {
      case 1:
        return '1.00';
      case 0:
        return '0.0';
      default:
        return String(number).substr(0, 4);
    }
  };

  selectIntent = () => this.props.onSelect(this.props.intent.id);

  render() {
    const {
      intent: {
        name,
        color,
        selection_entities,
        source,
        winning_constraint_set_name,
        score,
        confidence,
      },
    } = this.props;
    const { isExpanded } = this.state;

    return (
      <div
        styleName={cn('intent', {
          'is-ml': source === 'ml',
          'is-expanded': isExpanded,
        })}
      >
        <div style={{ borderLeft: `5px solid ${color}` }} styleName="header">
          {source !== 'ml' && (
            <i
              className={cn({
                'icon-triangle-arrow-up': isExpanded,
                'icon-triangle-arrow-down': !isExpanded,
              })}
              data-test={
                isExpanded ? 'collapse-result-button' : 'expand-result-button'
              }
              onClick={this.toggle}
            />
          )}

          <div
            data-test="test-result-title"
            styleName={cn('title', {
              'title--ml': source === 'ml',
            })}
          >
            <TextCropper placement="right" styleName="name" text={name} />

            {source === 'ml' ? (
              <MachineLearningPrediction />
            ) : (
              <span data-test="test-result-info" styleName="info">
                {winning_constraint_set_name}
              </span>
            )}
          </div>

          <div styleName="score">
            <span data-test="test-result-score-label">
              {source !== 'ml' ? 'SCORE:' : 'CONF:'}
            </span>
            <strong
              data-test="test-result-score-number"
              title={score || confidence || '0'}
            >
              {source !== 'ml'
                ? this.round(score, 1)
                : this.roundToTwoDecimals(confidence)}
            </strong>
          </div>
          <span
            data-test="edit-test-result"
            styleName="edit"
            onClick={this.selectIntent}
          >
            edit
          </span>
        </div>
        <Collapsible expanded={this.state.isExpanded}>
          <div className="content">
            <FeaturesList features={flattenFeatures(selection_entities)} />
          </div>
        </Collapsible>
      </div>
    );
  }
}
